import { createAction, props } from "@ngrx/store";
import { ServiceError, ServiceErrorWithList } from "../../create-request/models/shared/ServiceError";
import { DetailsResponse } from "../../create-request/models/wire/WireInfo";
import { StandingAuthorizationForm } from "../models/standingAuthorizationForm";
import { WireVerifyResponseV3 } from "../../create-request/models/wire/WireVerifyResponseV3";
import { WireInputResponseV3 } from "../../create-request/models/wire/WireInputResponseV3";
import { WireAcknowledgeResponseV3 } from "../../create-request/models/wire/WireAcknowledgeResponseV3";


export const callWireInputV3 = createAction(
    '[Create Standing Authorization - Wire] Call to Wire Input V3'
)

export const clearStandingAuthWireAuthResponse = createAction(
    '[Create Standing Authorization - Review Page] Clear Wires Auth Response for Custom Rules',
    props<{ state: any }>()
);

export const wireInputCallSuccessfulV3 = createAction(
    '[Create Standing Authorization - Wire] Call to Wire Input V3 succeeded',
    props<WireInputResponseV3>()
);

export const wireInputFailedV3 = createAction(
    '[Create Standing Authorization - Wire] Call to Wire Input V3 failed',
    props<ServiceError>()
);

export const wireDetailsCallLoading = createAction(
    '[Create Standing Authorization - Wire] - Show loading spinner for Wire Details'
);

export const callWireDetails = createAction(
    '[Create Standing Authorization - Wire] Call to Wire Details from Async Validator'
);

export const wireDetailsCallSuccessful = createAction(
    '[Create Standing Authorization - Wire] Call to Wire Details succeeded',
    props<DetailsResponse>()
);

export const wireDetailsCallFailed = createAction(
    '[Create Standing Authorization - Wire] Call to Wire Details failed',
    props<ServiceError>()
);

export const callWiresVerifyV3 = createAction(
    '[Create Standing Authorization - Wire] Call wires verify v3 for ISO 20022',
    props<StandingAuthorizationForm>()
);

export const verifyV3CallSuccessful = createAction(
  '[Create Standing Authorization - Wire] Call to verify V3 for ISO 20022 was successful',
  props<{response: WireVerifyResponseV3, inrReleaseFlowFromTable: boolean}>()
);

export const callAcknowledgeV3 = createAction(
  '[Create Standing Authorization - Wire] Call to standing Auth Acknowledge V3 '
);

export const callAcknowledgeV3ForCustomRules = createAction(
  '[Create Standing Authorization - Wire] Call to standing Auth Acknowledge V3 For Custom Rules Split Transaction'
);

export const verifyV3CallFailed = createAction(
    '[Create Standing Authorization - Wire] Error calling verify v3',
    props<ServiceErrorWithList>()
);

export const acknowledgeCallV3Successful = createAction(
  '[Create Standing Authorization - Wire] Call to Wire Acknowledge V3 was successful',
  props<WireAcknowledgeResponseV3>()
);

export const acknowledgeCallV3Fail = createAction(
  '[Create Standing Authorization - Wire] Call to Wire Acknowledge V3 failed',
  props<ServiceErrorWithList>()
);

export const loadWiresReviewPageWithoutVerifyCall = createAction(
    '[Create Standing Authorization] Load Wires Review page without calling verify endpoint',
    props<StandingAuthorizationForm>()
);
